import request from '@/utils/request';
//appid列表
export function getAppIdList() {
  return request('/wechat/queryWechatAccountList', {
    method: 'GET',
    // data: values,
  });
}
//appid列表
export function getMiniAppIdList() {
  return request('/wechat/mp/accountList', {
    method: 'POST',
    // data: values,
  });
}
//自动回复规则列表
export function getAutoReplyRulePage(values) {
  return request('/wechat/reply/queryReplyRulePage', {
    method: 'POST',
    data: values,
  });
}
//自动回复page
export function getAutoReplyPage(values) {
  return request('/wechat/reply/querySubscribeReply', {
    method: 'POST',
    data: values,
  });
}
//删除自动回复规则
export function deleteReplyRule(values) {
  return request('/wechat/reply/deleteReplyRule', {
    method: 'POST',
    data: values,
  });
}
//同步关注自动回复
export function synSubscribeReply(values) {
  return request('/wechat/reply/synSubscribeReply', {
    method: 'POST',
    data: values,
  });
}
//实时校验自动回复规则是否被应用
export function checkUseReplyRule(values) {
  return request('/wechat/reply/checkUseReplyRule', {
    method: 'POST',
    data: values,
  });
}
